import { Component, Input, OnInit } from '@angular/core';
import { Project } from '@project/shared/project.model';
import { UserService } from '@user/user.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'oes-project-header-tags',
  templateUrl: './project-header-tags.component.html',
  styleUrls: ['./project-header-tags.component.scss'],
})
export class ProjectHeaderTagsComponent implements OnInit {
  @Input() project: Project;
  canViewProgramLink: boolean = false;

  constructor(private _userService: UserService) {}

  ngOnInit() {
    this._userService.getCurrentUser()
      .pipe(take(1))
      .subscribe((user) => {
        const currentUserOrgId = user.organization.id;
        const isProjectOwner = this.project?.organization?.id === currentUserOrgId;
        const isProgramOwner = this.project?.program?.sponsor?.id === currentUserOrgId;

        // Show link if user is project owner or program sponsor
        this.canViewProgramLink = isProjectOwner || isProgramOwner;
      });
  }
}
